import {
  Button,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import {
  Container,
  ContainerForm,
  ContainerFormRight,
  Title,
} from "../../styles/index.sty";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useAuth } from "../../context/authContext";
import { useLists } from "../../context/listContext";
import {
  addSliderImage,
  insertSliderData,
  updateSliderData,
} from "../../api/slider.api";
import { useEffect } from "react";
import SliderImageSelect from "../../components/SliderImageSelect";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

export const AddSlider = () => {
  const { config, config2 } = useAuth();
  const {
    productCategoriesBarList,
    productCategoriesList,
    productSubCategoriesList,
    productsList,
    fetchProductCategoriesBarList,
    fetchProductCategoriesList,
    fetchProductSubCategoriesList,
    fetchProductsList,
  } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({});
  const data = location?.state?.data;

  const marks = [
    {
      value: 0,
      label: '1',
    },
    {
      value: 15,
      label: '2',
    },
    {
      value: 30,
      label: '3',
    },
    {
      value: 45,
      label: '4',
    },
    {
      value: 60,
      label: '5',
    },
    {
      value: 75,
      label: '6',
    },
    {
      value: 90,
      label: '7',
    },
    {
      value: 100,
      label: '8',
    },
  ];
  
  function valuetext(value) {
    return value+1;
  }
  let sliderImagesData = [];
  const [argument_id, setArgument_id] = useState(
    data?.argument_id || "page_id"
  );
  const [argument, setArgument] = useState(data?.argument || "page_id");
  const [file, setFile] = useState([]);

  const pageList = [
    {
      page_id: "home_page",
      page_name: "Home Page",
    },
    {
      page_id: "store_page",
      page_name: "Store Page",
    },
    {
      page_id: "profile_page",
      page_name: "Profile Page",
    },
    {
      page_id: "wishlist_page",
      page_name: "Wishlist Page",
    },
    {
      page_id: "cart_page",
      page_name: "Cart Page",
    },
  ];
  const [argumentArray, setArgumentArray] = useState(pageList);
  const [addImages, setAddImages] = useState(false);
  const [ finalImages, setFinalImages ] = useState([]);
  const [ images, setImages ] = useState([]);

  const updateNoOfImages = (e) => {
    setImages([]);
    const num = marks.find(el => el.value === e);
    // setImages(parseInt(num.label));
    for (let i = 0; i < parseInt(num.label); i++) {
      setImages(prev => [...prev, i]);
    }

  }

  const updateFinalImages = (i, data) => {
    const newArr = [...finalImages];
    newArr[i] = data;
    setFinalImages(newArr);
  }

  useEffect(() => {
    fetchProductCategoriesBarList();
    fetchProductCategoriesList();
    fetchProductSubCategoriesList();
    fetchProductsList();
  }, [data]);

  const argumentsList = [
    {
      key: "page_id",
      label: "Page",
    },
    {
      key: "product_category_bar_id",
      label: "Category Bar",
    },
    {
      key: "product_category_id",
      label: "Category",
    },
    {
      key: "product_sub_category_id",
      label: "Sub Category",
    },
    {
      key: "product_id",
      label: "Product",
    },
  ];

  const sliderTypeList = [
    {
      key: "Slides",
      label: "Slides",
    },
    {
      key: "Tiles",
      label: "Tiles",
    },
    {
      key: "Products",
      label: "Products",
    }
  ];

  const handleArgumentSelectMain = (e) => {
    setArgument(e.target.value);
    switch (e.target.value) {
      case "page_id":
        setArgumentArray(pageList);
        setArgument_id("");
        break;
      case "product_category_bar_id":
        setArgument_id("");
        setArgumentArray(productCategoriesBarList.filter(el => el.is_active !== 0));
        break;
      case "product_category_id":
        setArgument_id("");
        setArgumentArray(productCategoriesList.filter(el => el.is_active !== 0));
        break;
      case "product_sub_category_id":
        setArgument_id("");
        setArgumentArray(productSubCategoriesList.filter(el => el.is_active !== 0));
        break;
      case "product_id":
        setArgument_id("");
        setArgumentArray(productsList.filter(el => el.is_active !== 0));
        break;
      default:
        break;
    }
  };

  const formik = useFormik({
    initialValues: {
      slider_name: location?.state?.data?.slider_name || "",
      slider_type: location?.state?.data?.slider_type || "",
      slider_sub_heading: location?.state?.data?.slider_sub_heading || "",
      product_category_bar_id: location?.state?.data?.product_category_bar_id || "",
    },
    onSubmit: async (values) => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateSliderData(
          { ...values, slider_id: location?.state?.data?.slider_id },
          config
        );
        setResponse(submit);
        setOpen(true);
        if (submit.status === "success") {
          navigate("/slider");
        }
      } else {
        const submit = await insertSliderData(
          { ...values, argument, argument_id },
          config
        );
        setResponse(submit);
        console.log("===> this is submit", submit);
        if (submit.status === "success") {
          if (addImages) {
            finalImages.forEach(async (el) => {
              await addSliderImage(
                { slider_id: submit.data.slider_id, ...el },
                config2
              );
            });
          }
        }
        setLoading(false);
        navigate("/slider");      
      }
    },
  });

  useEffect(() => {
    console.log("===> this is the data", data);
    if (data && data["slider-images"].length > 0) {
      updateNoOfImages((data["slider-images"]?.length - 1) *15);
    }
  }, [data]);

  return (
    <>
      <Container>
        <Title variant="h5" className="w-[100%]">
          Enter Slider Details.
        </Title>
        <ContainerForm>
          {open && (
            <AlertSnack
              open={open}
              setOpen={setOpen}
              response={response}
              setLoading={setLoading}
              route="customers"
            />
          )}

          {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
          <div style={{ width: "60%", margin: "auto" }}>
            <FormGroup>
              <InputLabel id="demo-simple-select-label">Slider Type:<span className='text-[red]'>** </span></InputLabel>
              <Select
                id="demo-simple-select"
                value={formik.values.slider_type}
                name="slider_type"
                style={{ textAlign: "left" }}
                onChange={formik.handleChange}
              >
                <MenuItem value={""}>--SELECT--</MenuItem>
                {sliderTypeList.map((slider) => {
                  return (
                    <MenuItem value={slider.key} key={slider.key}>
                      {slider.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormGroup>
            <br />
            <FormGroup>
              <InputLabel id="demo-simple-select-label">Argument:<span className='text-[red]'>** </span></InputLabel>
              <Select
                id="demo-simple-select"
                value={argument}
                style={{ textAlign: "left" }}
                onChange={handleArgumentSelectMain}
              >
                <MenuItem value={""}>--SELECT--</MenuItem>
                {argumentsList.map((bar) => {
                  return (
                    <MenuItem value={bar.key} key={bar.key}>
                      {bar.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormGroup>
            <br />
            <FormGroup>
              <InputLabel id="demo-simple-select-label">
                Argument ID:<span className='text-[red]'>** </span>
              </InputLabel>
              <Select
                id="demo-simple-select"
                value={argument_id}
                style={{ textAlign: "left" }}
                onChange={(e) => {
                  setArgument_id(e.target.value);
                  if (argument === "product_category_bar_id") {
                    formik.values.product_category_bar_id = e.target.value;
                  }
                }}
              >
                <MenuItem value={""}>--SELECT--</MenuItem>
                {argumentArray?.map((arg, i) => {
                  return (
                    <MenuItem value={arg[argument]} key={arg[argument]}>
                      {arg[argument.replace("_id", "_name")]}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormGroup>
            <br />
            <FormGroup>
              <InputLabel htmlFor="slider_name">Slider Name:<span className='text-[red]'>** </span> </InputLabel>
              <OutlinedInput
                name="slider_name"
                placeholder="Enter Slider Name"
                id="slider_name"
                type="text"
                value={formik.values.slider_name}
                onChange={formik.handleChange}
              />
            </FormGroup>
            <br />
            <FormGroup>
              <InputLabel htmlFor="slider_sub_heading">
                Sub Heading:{" "}<span className='text-[red]'>** </span>
              </InputLabel>
              <OutlinedInput
                name="slider_sub_heading"
                placeholder="Enter Sub Heading"
                id="slider_sub_heading"
                type="text"
                value={formik.values.slider_sub_heading}
                onChange={formik.handleChange}
              />
            </FormGroup>
            <div className="flex flex-row justify-between">
              <Button
                type="button"
                variant="contained"
                color="info"
                onClick={() => navigate("/slider")}
                style={{
                  marginTop: "1rem",
                  width: "48%",
                }}
              >
                Back
              </Button>
              <Button
                type="button"
                variant="contained"
                color="info"
                onClick={formik.handleSubmit}
                style={{
                  marginTop: "1rem",
                  width: "48%",
                }}
              >
                Save & Continue
              </Button>
            </div>
          </div>
          }
        </ContainerForm>
        <ContainerFormRight>
          <Box sx={{ width: 300, m: "auto" }}>
            {
              data &&
                <Slider
                  aria-label="Custom marks"
                  defaultValue={ (data["slider-images"]?.length - 1) * 15 || 0}
                  getAriaValueText={valuetext}
                  step={15}
                  // valueLabelDisplay="auto"
                  marks={marks}
                  onChange={(e) => updateNoOfImages(e.target.value)}
                />

            }
          </Box>
          <Button
            variant="contained"
            onClick={() => setAddImages((prev) => !prev)}
          >
            {addImages ? "Remove" : "Add"} Images
          </Button>
          {addImages ? (
            <div className="flex flex-wrap justify-evenly">
              {
                images.map((el, i) => {
                  return (<div className="w-[45%] border-2 rounded-xl my-2" key={i}>
                    <SliderImageSelect
                      i={el}
                      pos={i}
                      data={data}
                      pageList={pageList}
                      argumentsList={argumentsList}
                      sliderImagesData={sliderImagesData}
                      updateFinalImages={updateFinalImages}
                      finalImages={finalImages}
                    />
                  </div>)
                })
              }
            </div>
          ) : null}
        </ContainerFormRight>
      </Container>
    </>
  );
};
